"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var oidc_client_1 = require("oidc-client");
var IdentityClient = /** @class */ (function () {
    function IdentityClient(options) {
        // get default scopes
        var _a;
        // set up UserManager
        var identitySettings = {
            authority: options.authority,
            silent_redirect_uri: options.signinFlow === "silent" && options.redirectUri
                ? options.redirectUri
                : options.silentRedirectUri,
            client_id: options.clientId,
            redirect_uri: options.redirectUri,
            response_type: "code",
            scope: options.scope,
            silentRequestTimeout: 30000,
            monitorSession: options.monitorSession === undefined ? false : options.monitorSession,
            loadUserInfo: true,
            userStore: new oidc_client_1.WebStorageStateStore({ store: new oidc_client_1.InMemoryWebStorage() })
        };
        this.userManager = new oidc_client_1.UserManager(identitySettings);
        // this address is use to requestReauthentication
        // whenever we get a login_required error
        this.workspaceUrl = options.workspaceUrl;
        this.signinFlow = (_a = options.signinFlow) !== null && _a !== void 0 ? _a : "silent";
    }
    Object.defineProperty(IdentityClient.prototype, "events", {
        get: function () {
            return this.userManager.events;
        },
        enumerable: false,
        configurable: true
    });
    IdentityClient.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this._getAccessTokenPromise) {
                    return [2 /*return*/, this._getAccessTokenPromise];
                }
                this._getAccessTokenPromise = new Promise(function (resolve, reject) {
                    _this.userManager
                        .getUser()
                        .then(function (user) {
                        if (user === null || user.expired) {
                            _this.userManager
                                .signinSilent()
                                .then(function (user) {
                                resolve(user.access_token);
                            })
                                .catch(function (err) {
                                reject(err);
                            });
                        }
                        else {
                            resolve(user.access_token);
                        }
                    })
                        .catch(function (err) {
                        reject(err);
                    });
                });
                this._getAccessTokenPromise
                    .then(function () {
                    _this._getAccessTokenPromise = undefined;
                })
                    .catch(function () {
                    _this._getAccessTokenPromise = undefined;
                });
                return [2 /*return*/, this._getAccessTokenPromise];
            });
        });
    };
    IdentityClient.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userManager.getUser().then(function (user) {
                        var _a, _b;
                        if (user) {
                            return {
                                emailAddress: (_a = user.profile.email) !== null && _a !== void 0 ? _a : "",
                                id: (_b = user.profile.acid) !== null && _b !== void 0 ? _b : undefined,
                                organisation: user.profile.org_id ? { id: user.profile.org_id } : undefined
                            };
                        }
                        else {
                            return undefined;
                        }
                    })];
            });
        });
    };
    IdentityClient.prototype.checkSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.userManager.getUser()];
                    case 1:
                        user = _a.sent();
                        if (!(user === null || user === undefined)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getAccessToken()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.log(error_1);
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    IdentityClient.prototype.requestReauthentication = function () {
        var message = {
            type: "RequestReauthentication"
        };
        window.parent.postMessage(JSON.stringify(message), this.workspaceUrl);
    };
    IdentityClient.prototype.signinRedirect = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.userManager.signinRedirect(args);
                return [2 /*return*/];
            });
        });
    };
    IdentityClient.prototype.signinCallback = function (url) {
        if (url === void 0) { url = window.location.href; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userManager.signinCallback(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return IdentityClient;
}());
exports.default = IdentityClient;
